import React from 'react';
import LegalPage from './LegalPage';

const PrivacyPage: React.FC = () => <LegalPage file="PRIVACY_POLICY.md" />;

export default PrivacyPage;
